{
  "OrganizationTalentsPage": {
    "title": "组织人才"
  },
  "ResourceTypesSettingsMenu": {
    "triggerLabel": "配置资源类型",
    "heading": "配置资源类型",
    "allTypes": "全部类型",
    "global": "在此组织",
    "workspace": "在此工作区",
    "thisTypeInWorkspace": "此工作区中的 {{name}}"
  },
  "ResourceRowGallery": {
    "failedToLoad": "加载 Pin 失败",
    "empty": "暂无 Pin",
    "addContactPins": "添加 Pin"
  },
  "AssignResourcesToWorkspacesDialog": {
    "title": "分配到工作区",
    "description_one": "选择 {{name}} 在工作区中的可见性。",
    "description_other": "选择这 {{count}} 个资源在工作区中的可见性。",
    "fieldScope": "可见性",
    "scopeHidden": "隐藏",
    "scopeHiddenHint": "无工作区成员关系 — 不出现在任何列表中（仅管理员）。",
    "scopeGlobal": "全局",
    "scopeGlobalHint": "在每个工作区可见（成员关系行的工作区 id 为空）。",
    "scopeWorkspaces": "指定工作区",
    "fieldWorkspaces": "工作区",
    "workspacesSelectPrompt": "选择一个或多个工作区",
    "workspacesSelectedCount": "已选 {{count}} 个",
    "workspacesUnselectAll": "取消全选",
    "workspacesEmpty": "暂无可用工作区",
    "save": "分配",
    "assignFailed": "分配工作区失败",
    "unsavedChangesBeforeUnload": "您有未保存的更改！",
    "success_one": "资源已分配到工作区",
    "success_other": "已将 {{count}} 个资源分配到工作区"
  },
  "ResourceWorkspacesCell": {
    "hidden": "隐藏",
    "global": "全局"
  },
  "ResourceCreateForm": {
    "profilePicture": "头像",
    "resourceType": "资源类型"
  },
  "ResourceCreateDialog": {
    "title": "创建资源",
    "titleTypeAndVisibility": "创建资源 · 类型和可见性",
    "titleType": "创建资源 · 类型",
    "titleDetails": "创建资源 · 详情",
    "description": "创建新资源",
    "actions": {
      "add-another": "保存并继续添加",
      "go-to-profile": "保存并前往个人资料",
      "close": "保存"
    },
    "createFailed": "创建资源失败",
    "noResourceTypes": "没有可用的资源类型。"
  },
  "CreateDraftSummary": {
    "change": "更改"
  },
  "ResourceDuplicatesFooter": {
    "title": "看起来眼熟？",
    "titleExact": "已存在同名资源",
    "summary_other": "{{count}} 个现有资源名称相似",
    "summaryNamed_other": "{{count}} 个现有资源与“{{name}}”相似",
    "review": "查看",
    "hide": "收起",
    "dismiss": "忽略",
    "exactMatch": "同名",
    "similarMatch": "相似",
    "openProfile": "打开",
    "openProfileOf": "在新标签页中打开 {{name}} 的资料",
    "hint": "资料会在新标签页中打开，草稿会保留在这里。不是同一个人？直接保存即可。"
  },
  "ResourceSchema": {
    "coreLabel": {
      "fullName": "全名",
      "pronouns": "代词",
      "emails": "电子邮箱",
      "phoneNumbers": "电话号码",
      "socials": "社交媒体",
      "websites": "网站",
      "tags": "标签",
      "groups": "分组",
      "locations": "地点",
      "rates": "费率",
      "agent": "经纪人",
      "organization": "机构",
      "nickname": "昵称",
      "role": "角色"
    },
    "enterPlaceholder": "输入{{label}}",
    "globalSection": "全局",
    "locationItemTitle": "地点",
    "rateItemTitle": "费率",
    "addRate": "添加费率",
    "blankRate": "空白费率",
    "blankRateHint": "输入金额",
    "fromRateCard": "从费率卡添加",
    "addItem": "添加{{name}}"
  },
  "ResourceEditorVersionSwitch": {
    "title": "资源编辑器",
    "newVersionDescription": "你正在试用新编辑器。它仍处于实验阶段——如有问题，可切换回经典版。你的数据不会改变。",
    "oldVersionDescription": "你正在使用经典编辑器。新编辑器处于测试阶段——随时可以试用。"
  },
  "ResourceNotesPanel": {
    "title": "备注",
    "fieldLabel": "新备注",
    "placeholder": "写一条备注…",
    "submit": "添加备注",
    "emptyTitle": "暂无备注",
    "emptyDescription": "记录关于 {{name}} 的备注。",
    "fallbackName": "此资源",
    "loadError": "无法加载备注。",
    "unknownUser": "未知用户",
    "deleteAria": "删除备注",
    "createdToast": "备注已添加",
    "createErrorToast": "无法添加备注",
    "deletedToast": "备注已删除",
    "deleteErrorToast": "无法删除备注"
  },
  "ResourceFilesPanel": {
    "title": "文档",
    "emptyTitle": "暂无文档",
    "emptyDescription": "管理 {{name}} 的重要文档和文件。",
    "fallbackName": "此资源",
    "loadError": "无法加载文档。",
    "untitled": "未命名文件",
    "uploadedToast": "文件已上传",
    "uploadErrorToast": "上传失败",
    "deletedToast": "文件已删除",
    "deleteErrorToast": "无法删除文件",
    "reorderErrorToast": "无法保存新的顺序"
  },
  "ResourcePane": {
    "invalidDataDescription": "我们仍会显示此表单，但它可能无法正常工作。如遇问题，请联系支持。"
  }
}
